import React, { useState, useEffect } from "react";
import Helmet from "react-helmet";
import { Modal } from "react-bootstrap";
import { withTranslation } from "react-i18next";
//components
import PageTitle from "../../components/common/pageTitle";
import { Tiles, Content } from "../../components/payout";
import ModalForms from "../../components/payout/ModalForms";
import AlertMessage from "../../components/common/AlertMessage";
//style
import style from "../../components/payout/payout.module.scss";
//service
import PayoutService from "../../../service/payout";
import companyName from "../../../store/mobxStore/companyName";
import Spinner from "../../shared/Spinner";
import { useSelector } from "react-redux";

import payoutdata from "./payoutdata.json";
import DropdownButton from "../../components/payout/DropDownButton";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { useHistory } from "react-router";
import PayoutModal from "../../components/payout/PayoutModal";
import NewModal from "../../components/payout/NewModal";
import swal from "sweetalert";

function Payout(props) {
  const { t } = props;
  const Currency = useSelector((state) => state.curr);
  const [reload, setReload] = useState(false);
  const [buttonItems, setButtonItems] = useState([]);
  const { location } = useHistory();
  const [state, setState] = useState({
    requestModal: false,
    tilesData: [],
    notifyOn: false,
    requestBtn: false,
    loading: true,
    notify: {
      message: "",
      type: "",
      header: "",
    },
    DataTables: {
      key: "paid",
      pending: {
        totalRows: 0,
        data: [],
        pending: true,
        perPage: 10,
        inpage: 1,
        selectedRows: [],
        closePopUp: false,
      },
      approved: {
        totalRows: 0,
        data: [],
        pending: true,
        perPage: 10,
        inpage: 1,
      },
      paid: {
        totalRows: 0,
        data: [],
        pending: true,
        perPage: 10,
        inpage: 1,
      },
      rejected: {
        totalRows: 0,
        data: [],
        pending: true,
        perPage: 10,
        inpage: 1,
      },
    },
    processingFee: 0,
    taxPercentage: 0,
    encashmentTypes: [],
    releaseMethod: [],
    addressDetails: [],
    bankDetailsArray: [],
    minPayOut: 0,
    bankValue: "",
    accountNumber: "",
    verified: false,
    pickupAddress: "",
    encashmentHistory: false,
    transactionWallet: false,
    transfer: false,
    releaseMethods: [],
    debitAmount: 0,
    debit_memo_text: "",
    reminder: "",
    disclaimer: "",
    confirmation_text: "",
    pdf: "",
    encashment_text:""
  });

  const [loader, setLoader] = useState({
    search: false,
    reset: false,
    excel: false,
    csv: false,
    print: false,
  });

  const service = new PayoutService();

  useEffect(() => {
    loadData();
  }, [reload]);

  const Translation = (data) =>
    Object.keys(data).map((item) => {
      return t("Common." + data[item]);
    });

  const addCurrency = (data) => {
    let newData = data.map((item) => {
      if (state.DataTables.key == "pending") {
        return {
          ...item,
          ewallet_balance: `${Currency.currentCurr}${(
            parseFloat(item.ewallet_balance) * Currency.value
          ).toFixed(Currency.precision)}`,
          payout_amount: `${Currency.currentCurr}${(
            parseFloat(item.payout_amount) * Currency.value
          ).toFixed(Currency.precision)}`,
        };
      }
      if (
        state.DataTables.key == "paid" ||
        state.DataTables.key == "approved" ||
        state.DataTables.key == "rejected"
      ) {
        return {
          ...item,
          amount: `${Currency.currentCurr}${(
            parseFloat(item.amount) * Currency.value
          ).toFixed(Currency.precision)}`,
          processingFee: `${Currency.currentCurr}${(
            parseFloat(item.processingFee) * Currency.value
          ).toFixed(Currency.precision)}`,
          tax: `${Currency.currentCurr}${(
            parseFloat(item.tax) * Currency.value
          ).toFixed(Currency.precision)}`,
          net_amount: `${Currency.currentCurr}${(
            parseFloat(item.net_amount) * Currency.value
          ).toFixed(Currency.precision)}`,
          release_method	: t(`payout.${item.release_method	}`),
        };
      } else if (state.DataTables.key === "type") {
        return {
          ...item,
          type: t(`payout.${item.release_method}`),
        };
      } else return item;
    });
    return newData;
  };

  const ExportToExcel = (apiData, fileName, type) => {
    let fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    let fileExtension = ".xlsx";

    if (type === "excel") {
      // const exportToCSV = (apiData, fileName) => {
      const ws = XLSX.utils.json_to_sheet(addCurrency(apiData));
      console.log(ws);
      if (apiData.length > 0) {
        XLSX.utils.sheet_add_aoa(ws, [Translation(Object.keys(apiData[0]))]);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);
        setLoader({
          search: false,
          reset: false,
          excel: false,
          csv: false,
          print: false,
        });
      } else {
        setLoader({
          search: false,
          reset: false,
          excel: false,
          csv: false,
          print: false,
        });
      }
      // };
    } else if (type === "csv") {
      fileExtension = ".csv";
      let fileType = "text/csv;charset=utf-8";
      const ws = XLSX.utils.json_to_sheet(addCurrency(apiData));
      if (apiData.length > 0) {
        XLSX.utils.sheet_add_aoa(ws, [Translation(Object.keys(apiData[0]))]);
        const csvOutput = XLSX.utils.sheet_to_csv(ws);
        const data = new Blob([csvOutput], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);
        setLoader({
          search: false,
          reset: false,
          excel: false,
          csv: false,
          print: false,
        });
      } else {
        setLoader({
          search: false,
          reset: false,
          excel: false,
          csv: false,
          print: false,
        });
      }
    } else if (type === "print") {
      //  let printView = <UserEarningsPrintView
      //      data={apiData}
      // />
    }
  };

  const removeData = (data) => {
    let newdata = data.filter((item, key) => {
      delete item["request_id"];

      return t(item);
    });

    return newdata;
  };
  // Export Data
  const exportData = (type, StartDate, EndDate) => {
    if (type === "excel") {
      setLoader({
        search: false,
        reset: false,
        excel: true,
        csv: false,
        print: false,
      });
    } else if (type === "csv") {
      setLoader({
        search: false,
        reset: false,
        excel: false,
        csv: true,
        print: false,
      });
    }
    if (type === "print") {
      setLoader({
        search: false,
        reset: false,
        excel: false,
        csv: false,
        print: true,
      });
    }
    service.exportData(0, 1000, StartDate, EndDate).then((res) => {
      if (type === "excel") {
        ExportToExcel(removeData(res.data.table_data), "Payout Pending", type);
      }
      if (type === "csv") {
        ExportToExcel(removeData(res.data.table_data), "Payout Pending", type);
      }
      if (type === "print") {
        ExportToExcel(removeData(res.data.table_data), "Payout Pending", type);
      }
    });
  };

  //initial loading
  const loadData = () => {
    setState((prevState) => ({
      ...prevState,
      requestBtn: payoutdata.button_show,
      tilesData: payoutdata.payout_tile,
      loading: false,
      taxPercentage: 0,
      processingFee: 0,
      encashmentTypes: [],
      releaseMethod: [],
      addressDetails: [],
      bankDetailsArray: [],
      minPayOut: 0,
      bankValue: "",
      accountNumber: "",
      verified: false,
      debitAmount: 0,
      debit_memo_text: "",
      reminder: "",
      disclaimer: "",
      confirmation_text: "",
      pdf: "",
      encashment_text:""
    }));
    service.PayoutTiles().then((res) => {
      if (res.status) {
        setState((prevState) => ({
          ...prevState,
          requestBtn: res.data.button_show,
          tilesData: res.data.payout_tile,
          loading: false,
          taxPercentage: res.data.taxPercentage,
          processingFee: res.data.processingFee,
          minPayOut: res.data.minPayOut,
          encashmentTypes: res.data.encashmentTypes,
          releaseMethod: res.data.releaseMethod,
          addressDetails: res.data.addressDetails,
          bankDetailsArray: res.data.bankDetailsArray,
          bankValue: res.data.bankValue,
          accountNumber: res.data.accountNumber,
          verified: res.data.verified,
          pickupAddress: res.data.pickupAddress,
          encashmentHistory: res.data.encashmentHistory,
          transactionWallet: res.data.transactionWallet,
          transfer: res.data.transfer,
          releaseMethods: res.data.releaseMethods,
          debitAmount: res.data.debitMemo.status
            ? res.data.debitMemo.amount
            : 0,
          debit_memo_text: res.data.debit_memo_text ?? "",
          reminder: res.data.reminder ?? "",
          disclaimer: res.data.disclaimer ?? "",
          confirmation_text: res.data.confirmation_text ?? "",
          pdf: res.data.pickup_file ?? "",
          encashment_text:res.data.encashment_text ?? ""
        }));
      }
    });
    //getPaidTable();
    getPendingTable();
  };
  //get the pending table
  const getPendingTable = (
    inPage = state.DataTables.pending.inpage,
    perPage = state.DataTables.pending.perPage
  ) => {
    let start = (inPage - 1) * perPage;
    service.PayoutTiles(start, perPage).then((res) => {
      if (res.status) {
        setLoader({
          search: false,
          reset: false,
        });

        setState((prevState) => ({
          ...prevState,
          DataTables: {
            ...prevState.DataTables,
            pending: {
              ...prevState.DataTables.pending,
              totalRows: res.data.count,
              data: res.data.table_data,
              pending: false,
            },
          },
        }));
      }
    });
  };

  //pagination change
  const changePendingTable = (inPage, perPage, order = "", dierection = "") => {
    setState((prevState) => ({
      ...prevState,
      DataTables: {
        ...prevState.DataTables,
        pending: {
          ...prevState.DataTables.pending,
          perPage: perPage,
          inPage: inPage,
          pending: true,
        },
      },
    }));
    getPendingTable(inPage, perPage);
  };

  //close the selected popup
  const cancelPopup = (row, isCancel) => {
    setState((prevState) => ({
      ...prevState,
      DataTables: {
        ...prevState.DataTables,
        pending: {
          ...prevState.DataTables.pending,
          selectedRows: row,
          closePopUp: isCancel,
        },
      },
    }));
  };

  //cancel submit
  const CancelSubmit = () => {
    // let cancelationData = new FormData();
    let payouts = [];
    state.DataTables.pending.selectedRows.forEach((element) => {
      payouts.push(element);
    });
    service.CancelRequest(payouts).then((res) => {
      if (res.status) {
        setState((prevState) => ({
          ...prevState,
          notifyOn: true,
          notify: {
            ...prevState.notify,
            message: res.data.message,
            type: "success",
            header: props.t("Common.Success"),
          },
          DataTables: {
            ...prevState.DataTables,
            pending: {
              ...prevState.DataTables.pending,
              selectedRows: [],
              closePopUp: false,
            },
          },
        }));

        getPendingTable();
        loadData();
      } else {
        if (res.error.code === 1019) {
        }
      }
    });
    loadData();
  };

  const getApprovedTable = (
    inPage = state.DataTables.approved.inpage,
    perPage = state.DataTables.approved.perPage,
    order = "",
    dierection = ""
  ) => {
    let start = (inPage - 1) * perPage;
    service.ApprovedTable(start, perPage, order, dierection).then((res) => {
      if (res.status) {
        setLoader({
          search: false,
          reset: false,
        });

        setState((prevState) => ({
          ...prevState,
          DataTables: {
            ...prevState.DataTables,
            approved: {
              ...prevState.DataTables.approved,
              totalRows: res.data.count,
              data: res.data.table_data,
              pending: false,
            },
          },
        }));
      }
    });
  };
  //change Approved Table paignation change
  const changeApprovedTable = (
    inPage,
    perPage,
    order = "",
    dierection = ""
  ) => {
    setState((prevState) => ({
      ...prevState,
      DataTables: {
        ...prevState.DataTables,
        approved: {
          ...prevState.DataTables.approved,
          perPage: perPage,
          inPage: inPage,
          pending: true,
        },
      },
    }));
    getApprovedTable(inPage, perPage, order, dierection);
  };

  //get Paid table datat
  const getPaidTable = (
    inPage = state.DataTables.paid.inpage,
    perPage = state.DataTables.paid.perPage,
    order = "",
    dierection = ""
  ) => {
    let start = (inPage - 1) * perPage;
    service.PaidTable(start, perPage, order, dierection).then((res) => {
      if (res.status) {
        setLoader({
          search: false,
          reset: false,
        });

        setState((prevState) => ({
          ...prevState,
          DataTables: {
            ...prevState.DataTables,
            paid: {
              ...prevState.DataTables.paid,
              totalRows: res.data.count,
              data: res.data.table_data,
              pending: false,
            },
          },
        }));
      }
    });
  };

  //change paid data table
  const changePaidTable = (inPage, perPage, order = "", dierection = "") => {
    setState((prevState) => ({
      ...prevState,
      DataTables: {
        ...prevState.DataTables,
        paid: {
          ...prevState.DataTables.paid,
          perPage: perPage,
          inPage: inPage,
          pending: true,
        },
      },
    }));
    getPaidTable(inPage, perPage, order, dierection);
  };

  //get the rejected table data
  const getRejectedTable = (
    inPage = state.DataTables.rejected.inpage,
    perPage = state.DataTables.rejected.perPage,
    order = "",
    dierection = ""
  ) => {
    let start = (inPage - 1) * perPage;
    service.RejectedTable(start, perPage, order, dierection).then((res) => {
      if (res.status) {
        setLoader({
          search: false,
          reset: false,
        });

        setState((prevState) => ({
          ...prevState,
          DataTables: {
            ...prevState.DataTables,
            rejected: {
              ...prevState.DataTables.rejected,
              totalRows: res.data.count,
              data: res.data.table_data,
              pending: false,
            },
          },
        }));
      }
    });
  };

  //change rejecte
  const changeRejectedTable = (
    inPage,
    perPage,
    order = "",
    dierection = ""
  ) => {
    setState((prevState) => ({
      ...prevState,
      DataTables: {
        ...prevState.DataTables,
        rejected: {
          ...prevState.DataTables.rejected,
          perPage: perPage,
          inPage: inPage,
          pending: true,
        },
      },
    }));
    getRejectedTable(inPage, perPage, order, dierection);
  };

  //tab change
  const changePageDrop = (key) => {
    setState((prevState) => ({
      ...prevState,
      DataTables: {
        ...prevState.DataTables,
        key: key,
      },
    }));

    if (key === "pending") {
      getPendingTable();
    } else if (key === "approved") {
      getApprovedTable();
    } else if (key === "paid") {
      getPaidTable();
    } else if (key === "rejected") {
      getRejectedTable();
    }
  };

  //modal open
  const requestModalOpen = () => {
    setState((prevState) => ({
      ...prevState,
      requestModal: true,
    }));
  };

  //notifydismissed
  const notifyDissmissed = () => {
    setState((prevState) => ({
      ...prevState,
      notifyOn: false,
    }));
  };

  const buttonGroups = [
    {
      name: "payoutRequest",
      click: requestModalOpen,
    },
  ];

  const paginationHandler = {
    pending: changePendingTable,
    approved: changeApprovedTable,
    paid: changePaidTable,
    rejected: changeRejectedTable,
    cancel: cancelPopup,
    submit: CancelSubmit,
  };

  const items = [
    { id: 1, label: "Transaction Wallet" },
    { id: 3, label: "Encashment Request" },
  ];

  useEffect(() => {
    const newItems = [];
    if (state.transactionWallet) {
      newItems.push({ id: 1, label: "Transaction Wallet" });
    }
    if (state.transfer) {
      newItems.push({ id: 3, label: "Encashment Request" });
    }
    setButtonItems(newItems);
  }, [state.transactionWallet, state.encashmentHistory]);

  const [selectedItems, setSelectedItems] = useState([]);


  const itemHandleClickDueToDebitMemo = (item) => {
    const itemIndex = selectedItems.findIndex(
      (selectedItem) => selectedItem.id === item.id
    );
    if (itemIndex === -1) {
      const newSelectedItems = [
        ...selectedItems,
        { ...item, displayModal: true },
      ];
      setSelectedItems(newSelectedItems);
    } else {
      const newSelectedItems = [...selectedItems];
      newSelectedItems[itemIndex].displayModal = true;
      setSelectedItems(newSelectedItems);
    }
  }
  const handleItemClick = async (item) => {
    console.log(state.debitAmount,"state");
    console.log(`Clicked item: ${item.label}`);

    if(state.debitAmount > 0 ) {
      const transactionWrapper = document.createElement("div");
          transactionWrapper.innerHTML =state.encashment_text ?? "";
      const confirmTransaction = await swal({
        title: "Important Notice",
        content: transactionWrapper,
        icon: "info",
        buttons: ["Cancel", "Proceed"],
        dangerMode: true,
      });

      if(confirmTransaction){
        itemHandleClickDueToDebitMemo(item);
      }
    }else{
      const itemIndex = selectedItems.findIndex(
        (selectedItem) => selectedItem.id === item.id
      );
      if (itemIndex === -1) {
        const newSelectedItems = [
          ...selectedItems,
          { ...item, displayModal: true },
        ];
        setSelectedItems(newSelectedItems);
      } else {
        const newSelectedItems = [...selectedItems];
        newSelectedItems[itemIndex].displayModal = true;
        setSelectedItems(newSelectedItems);
      }
    }
    
  };

  const handleCloseModal = (itemId) => {
    const itemIndex = selectedItems.findIndex(
      (selectedItem) => selectedItem.id === itemId
    );
    const newSelectedItems = [...selectedItems];
    newSelectedItems[itemIndex].displayModal = false;
    setSelectedItems(newSelectedItems);
  };

  console.log({ buttonItems });
  return (
    <div className="h-100">
      <Helmet>
        <title>
          {companyName.companyName} | {t("Sidemenu.payout")}
        </title>
      </Helmet>
      <PageTitle
        title="payout"
        buttonOn={state.requestBtn}
        group={buttonGroups}
      />
      {state.loading ? (
        <Spinner />
      ) : (
        <>
          <div className="container" style={{ paddingBottom: "1rem" }}>
            <DropdownButton
              buttonText={<>ENCASHMENT REQUEST</>}
              items={buttonItems}
              onItemClick={handleItemClick}
            />
            {selectedItems.map((selectedItem) =>
              selectedItem.displayModal ? (
                <NewModal
                  key={selectedItem.id}
                  item={selectedItem}
                  onClose={() => handleCloseModal(selectedItem.id)}
                  taxPercentage={state.taxPercentage}
                  processingFee={state.processingFee}
                  encashmentTypes={state.encashmentTypes}
                  releaseMethod={state.releaseMethod}
                  addressDetails={state.addressDetails}
                  bankDetailsArray={state.bankDetailsArray}
                  minPayOut={state.minPayOut}
                  bankValue={state.bankValue}
                  accountNumber={state.accountNumber}
                  verified={state.verified}
                  pickupAddress={state.pickupAddress}
                  setReload={setReload}
                  changePageDrop={changePageDrop}
                  releaseMethods={state.releaseMethods}
                  debitAmount={state.debitAmount}
                  debit_memo_text={state.debit_memo_text}
                  reminder={state.reminder}
                  disclaimer={state.disclaimer}
                  confirmation_text={state.confirmation_text}
                  pdf={state.pdf}
                />
              ) : null
            )}
          </div>
          <div className={style.MainContainer} style={{ marginTop: "8rem" }}>
            <Tiles tilesData={state.tilesData} />
            <Content
              changeHandler={changePageDrop}
              paginationHandler={paginationHandler}
              exportData={exportData}
              loader={loader}
              encashmentHistory={state.encashmentHistory}
            />
            {state.notifyOn && (
              <AlertMessage
                message={state.notify.message}
                dismiss={notifyDissmissed}
                type={state.notify.type}
                header={state.notify.header}
                show={state.notifyOn}
              />
            )}
          </div>
        </>
      )}
    </div>
  );
}
export default withTranslation()(Payout);
